import React, { Fragment } from "react";

const TYPES = {
  4: "fa-brands fa-cc-visa fa-xl",
  5: "fa-brands fa-cc-mastercard fa-xl",
  3: "fa-brands fa-cc-amex fa-xl",
};

export default function TypeOfCard({ number }) {
  const type = TYPES[number[0]];

  return (
    <aside className="flex-right">
      {type ? (
        <i className={type} />
      ) : (
        <Fragment>
          <i className="fa-brands fa-cc-visa fa-xl" />
          <i className="fa-brands fa-cc-mastercard fa-xl" />
          <i className="fa-brands fa-cc-amex fa-xl" />
        </Fragment>
      )}
    </aside>
  );
}



// WEBPACK FOOTER //
// ./src/components/TypeOfCard/index.jsx